/**
 * MDM Constants and Configuration
 *
 * Purpose: Centralized configuration for Master Data Management components
 * Author: Development Team
 * Created: 2025-01-04
 */

import { ChipProps } from '@mui/material';

/**
 * Scope types for MDM values
 */
export enum MDMScope {
  GLOBAL = 'GLOBAL',
  LOCAL = 'LOCAL',
  OVERRIDDEN = 'OVERRIDDEN',
}

/**
 * Centralized scope chip color configuration
 * Maps scope types to Material-UI chip colors
 */
export const SCOPE_CHIP_COLORS: Record<MDMScope, ChipProps['color']> = {
  [MDMScope.GLOBAL]: 'default', // Gray
  [MDMScope.LOCAL]: 'primary', // Blue
  [MDMScope.OVERRIDDEN]: 'success', // Green
};

/**
 * Helper function to get chip color based on scope
 * @param scope - The scope string (GLOBAL, LOCAL, or OVERRIDDEN)
 * @returns The Material-UI chip color
 */
export function getScopeChipColor(scope: string): ChipProps['color'] {
  return SCOPE_CHIP_COLORS[scope as MDMScope] || 'default';
}

/**
 * Scope descriptions for tooltips and help text
 */
export const SCOPE_DESCRIPTIONS: Record<MDMScope, string> = {
  [MDMScope.GLOBAL]: 'System-wide value available to all tenants',
  [MDMScope.LOCAL]: 'Tenant-specific value',
  [MDMScope.OVERRIDDEN]: 'Tenant override of a global value',
};
